import type { ComponentProps } from "react";

import { cn } from "@/services/styles/cn";

export interface BottomNavProps extends ComponentProps<"nav"> {}

export function MobileNavbar({ className, children, ...props }: BottomNavProps) {
  return (
    <nav
      className={cn(
        "fixed inset-x-0 bottom-0 z-10 flex h-16 border-t border-t-grey-100 bg-white shadow-2xl",
        className,
      )}
      {...props}
    >
      <ul className="-top-px absolute inset-0 grid grid-cols-5">{children}</ul>
    </nav>
  );
}
